import {Button, Form, Modal} from "react-bootstrap";
import React, {FC, useState, useEffect} from "react";
import {BlackListUser} from "services/blackListService";

interface UpdateBlackListModalProps {
    isModalVisible: boolean;
    setIsModalVisible: (v: boolean) => void;
    handleSave: (v: { name: string, photos: File[] }) => Promise<void>;
    selectedUser?: BlackListUser | null;
}

export const UpdateBlackListModal: FC<UpdateBlackListModalProps> =
    ({
         isModalVisible,
         setIsModalVisible,
         handleSave,
         selectedUser
     }) => {
        const [name, setName] = useState('');
        const [photos, setPhotos] = useState<File[]>([]);

        useEffect(() => {
            if (selectedUser && isModalVisible) {
                setName(selectedUser.name);
            } else if (!isModalVisible) {
                setName('');
                setPhotos([]);
            }
        }, [selectedUser, isModalVisible]);

        const handleClose = (didChange?: boolean) => {
            setName('');
            setPhotos([]);
            setIsModalVisible(false);
        }

        return <Modal show={isModalVisible} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>{selectedUser ? 'Добавить фото к пользователю' : 'Добавить в Черный Список'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                        <Form.Label>Имя</Form.Label>
                        <Form.Control 
                            type="text" 
                            placeholder="Имя пользователя"
                            value={name}
                            onChange={e => setName(e.target.value)}
                            readOnly={!!selectedUser}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                        <Form.Label>Фото</Form.Label>
                        <div className="d-flex flex-row">
                            <Form.Control
                                type="file" multiple={true}
                                placeholder="Фото пользователя"
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                    if (e.target.files) {
                                        setPhotos(Array.from(e.target.files));
                                    }
                                }}/>
                        </div>
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => handleClose()}>
                    Закрыть
                </Button>
                <Button disabled={!name || !photos.length} variant="primary"
                        onClick={async () => {
                            await handleSave({name, photos})
                            handleClose()
                        }}>
                    Сохранить
                </Button>
            </Modal.Footer>
        </Modal>
    }